<template>
  <div class="mediaandawards">
    <NavBar :mainPage="mainPage" />
    <section id="media-intro" ref="awardsstart">
      <Mediaintro :heading="headings.first" :paragraph="paragraph.first" />
    </section>
    <section id="media-recognition" class="media-recognition mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Recognition Headings Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="recog-head">Recognition</div>
      </div>
      <div class="recognition-mid-section">
      <Recognition
        class="recognition"
        :heading="headings.second"
        :paragraph="paragraph.second"
        :images="images"
        headingVisible="true"
      />
      </div>
    </section>
    <section id="awards" class="awards mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Awards Headings Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="awards-head">Awards</div>
      </div>
      <div class="awards-mid-section">
      <Awards :logos="awardLogos" id="awards-logos" class="awards-main-section" />
      </div>
    </section>
    <section id="video-carousel" class="mid">
    <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="video-carousel-image-bg" alt="Videos Headings Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="video-carousel-head">Videos</div>
      </div>
       <div class="video-carousel-mid-section">
      <Videocarousel :videos="videos" />
      </div>
    </section>
    <section id="media" class="medias mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Media Headings Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="media-head">Media</div>
      </div>
       <div class="media-mid-section">
      <Media class="media-b" :logos="logos" />
      </div>
    </section>
    <section id="partners" class="partners mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="PartnersHeadings Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="partners-head">External Partners</div>
      </div>
       <div class="partners-mid-section">
      <Partners class="partners-body" :partners="partners" />
      </div>
    </section>
    <section id="foot" v-lazy:background-image ="require(`@/assets/background/footer_bg.png`)">
      <Footer />
    </section>
  </div>
</template>
<script>
import Mediaintro from "./media-intro";
import Recognition from "./recognition";
import Awards from "./awards";
//import Videocarousel from "./video-carousel";
const Videocarousel = () => import('./video-carousel');
import Media from "./media";
import Partners from "./partners";

export default {
  name: "MediaandAwards",
  components: {
    Mediaintro,
    Recognition,
    Awards,
    Videocarousel,
    Media,
    Partners,
  },
  data() {
    return {
      mainPage: false,
      headings: {
        first: "Media and Awards ",
        second: "Recognition",
        third: "Awards",
        fourth: "Media",
        fifth: "External Partners",
      },
      images: [
        {
          image: "award1.jpg",
          description:
            "Our CEO, Mr. Sanjeev Chandak meeting Honorable Queen Maxima of Netherlands",
          visit_url: "#",
        },
        {
          image: "award2.jpg",
          description:
            "Winner of MIT Inclusive Innovation Challenge",
          visit_url: "#",
        },
        {
          image: "award3.jpg",
          description:
            "Invited by Honorable President of India to Rashtrapati Bhavan to celebrate festival of innovation day",
          visit_url: "#",
        },
        {
          image: "award5.jpg",
          description:
            "Winner of Prestigious Award at NTT Data Open Innovation – Global Grand Finale in Tokyo",
          visit_url: "#",
        },
        {
          image: "award7.jpg",
          description:
            "Winner for ReTech Startup Awards 2016 hosted by the Retailers Association of India",
          visit_url: "#",
        },
      ],
      simpleLogos: {
        logo1: "Forbes_logo.png",
        logo2: "cnbc-logo.jpg",
        logo3: "wall_street_logo.png",
        logo4: "kellogg_logo.png",
        logo5: "Techcrunch_logo.png",
        logo6: "Verve_logo.png",
        logo7: "bussinessworld_logo.png",
      },
      logos: [
        {
          logo: "wall_street_logo.png",
          description:
            "Some Good Tech News: Entrepreneurs Leverage Tech for Economic Inclusion",
          visit_url:
            "https://blogs.wsj.com/cio/2018/11/23/some-good-tech-news-entrepreneurs-leverage-tech-for-economic-inclusion/",
        },
        {
          logo: "Techcrunch_logo.png",
          description:
            "ftcash helps Indian businesses accept cashless payments and loans them money",
          visit_url: "https://techcrunch.com/2017/12/04/ftcash/",
        },
        {
          logo: "ndtv_real_deal.png",
          description: "Meet The Real Deal Contestant: Vaibhav Lodha",
          visit_url:
            "https://sites.ndtv.com/therealdeal/video-detail/meet-the-real-deal-contestant-vaibhav-lodha-410065/",
        },
        {
          logo: "times_of_india.png",
          description:
            "ftcash gets Rs 1 crore in pre-series A funding from IvyCap",
          visit_url:
            "http://timesofindia.indiatimes.com/tech/tech-news/FTCash-gets-Rs-1-crore-in-pre-series-A-funding-from-IvyCamp/articleshow/51240457.cms",
        },
        {
          logo: "Forbes_logo.png",
          description: "Fintech firms are a blessing for small entrepreneurs",
          visit_url:
            "https://www.forbesindia.com/article/work-in-progress/hold-on-my-wallets-in-my-phone-fintech-firms-are-a-blessing-for-small-entrepreneurs/43765/0",
        },
        {
          logo: "cnbc-logo.jpg",
          description:
            "Startups raising funds live at Young Turks TiE The Knot",
          visit_url: "https://youtu.be/7QbAd-kH4Pk?t=458",
        },
        {
          logo: "kellogg_logo.png",
          description: "Stripe: Helping Money Move on the Internet",
          visit_url:
            "https://drive.google.com/file/d/1e5zQ_6Lk0dl8sd6cG8tbpHRfk97nATPV/view?usp=sharing",
        },
        {
          logo: "Verve_logo.png",
          description:
            "Vaibhav Lodha talks about India’s thriving Fintech scene",
          visit_url: "https://www.vervemagazine.in/tag/ftcash",
        },
        {
          logo: "economic_times.png",
          description: "ftcash raises Rs 50 crore in Series A",
          visit_url:
            "https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/ftcash-raises-rs-50-crore-in-series-a/articleshow/69155180.cms",
        },
        {
          logo: "hindu.png",
          description: "4 start-ups make it to PayPal incubation programme",
          visit_url:
            "https://www.thehindubusinessline.com/info-tech/4-startups-make-it-to-paypal-incubation-programme/article7838474.ece",
        },
        {
          logo: "crunchbase.png",
          description: "Crunchbase - Top Hot Tech Companies Globally for 2019",
          visit_url:
            "https://about.crunchbase.com/blog/50-hottest-tech-companies-2019/",
        },
        {
          logo: "business_line.png",
          description:
            "Fintech lender ftcash raises Rs 50 crore in Series A funding-round",
          visit_url:
            "https://www.thehindubusinessline.com/companies/fintech-lender-ftcash-raises-rs-50-crore-in-series-a-funding-round/article27012710.ece",
        },
        {
          logo: "business_world.png",
          description: "Ftcash: No Cash, Please",
          visit_url:
            "http://www.businessworld.in/article/Ftcash-No-Cash-Please/25-10-2016-107356/",
        },
        {
          logo: "inc_42.png",
          description:
            "Micro-Lending Startup Ftcash Raises $7.23 Mn Series A Funding",
          visit_url:
            "https://inc42.com/buzz/micro-lending-ftcash-series-a-funding/",
        },
        {
          logo: "et_rise.png",
          description: "ftcash raises Rs 50 crore in Series A",
          visit_url:
            "https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/ftcash-raises-rs-50-crore-in-series-a/articleshow/69155180.cms",
        },
        {
          logo: "bw_disrupt.png",
          description:
            "ftcash Raises Funding at Pitch@RB, Signs MoU with IvyCap Ventures",
          visit_url:
            "http://bwdisrupt.businessworld.in/article/ftcash-Raises-Funding-at-Pitch-RB-Signs-MoU-with-IvyCap-Ventures/11-03-2017-114252/",
        },
        {
          logo: "midday.png",
          description: "Easy breezy Will-Kat impress young innovators",
          visit_url:
            "https://www.mid-day.com/articles/mumbai-easy-breezy-will-kat-impress-young-innovators/17126168",
        },
        {
          logo: "business_standard.png",
          description: "ftcash raises Rs 1 cr in pre-Series A round",
          visit_url:
            "https://www.business-standard.com/article/companies/ftcash-raises-rs-1-cr-in-pre-series-a-round-116030300595_1.html",
        },
        {
          logo: "nikkei.png",
          description: "In India, technology helps the unbankable to bank",
          visit_url:
            "https://asia.nikkei.com/Business/Trends/In-India-technology-helps-the-unbankable-to-bank?page=2",
        },
        {
          logo: "free_press.png",
          description: "Bootstrapping or angel investment?",
          visit_url:
            "https://www.freepressjournal.in/business/bootstrapping-or-angel-investment",
        },
        {
          logo: "live_mint.png",
          description: "No change? No problem",
          visit_url:
            "https://www.livemint.com/Companies/6ugLSlJJaaLlMHwdMcazzL/No-change-No-problem.html",
        },
        {
          logo: "et_tech.png",
          description: "Ftcash raises funds from 500 Startups",
          visit_url:
            "http://tech.economictimes.indiatimes.com/news/startups/ftcash-raises-funds-from-500-startups/59010090",
        },
        {
          logo: "vccircle.png",
          description: "Fin-tech startup Ftcash raises Series A funding",
          visit_url:
            "https://www.vccircle.com/us-non-profit-accion-dutch-bank-fmo-lead-funding-in-fin-tech-startup-ftcash/",
        },
        {
          logo: "your_story.png",
          description:
            "Mumbai-based fintech startup ftcash raises Rs 50 Cr from Accion, FMO, and IvyCap Ventures",
          visit_url:
            "https://yourstory.com/2019/05/mumbai-fintech-startup-ftcash-funding-fmo",
        },
        {
          logo: "accion.png",
          description: "ftcash Raises Approx. $7.2M in Series A Funding",
          visit_url:
            "https://www.accion.org/ftcash-raises-approx-7-2m-in-series-a-funding",
        },
        {
          logo: "owler.png",
          description:
            "ftcash's Competitors, Revenue, Number of Employees, Funding and Acquisition",
          visit_url: "https://www.owler.com/company/ftcash",
        },
        {
          logo: "tech_circle.png",
          description:
            "Fintech startup ftcash raises $7.22 mn in Series A round led by Dutch lender FMO",
          visit_url:
            "https://www.techcircle.in/2019/05/03/fintech-startup-ftcash-raises-7-22-mn-in-series-a-round-led-by-dutch-lender-fmo",
        },
        {
          logo: "medianama.png",
          description:
            "Payments company Ftcash raises pre-series A round: report",
          visit_url:
            "https://www.medianama.com/2017/06/223-ftcash-funding-500-startups/",
        },
        {
          logo: "angel_list.png",
          description: "Payments Anytime Anywhere",
          visit_url: "https://angel.co/company/ftcash",
        },
        {
          logo: "innovation_hub.png",
          description:
            "Ten startups graduate from Facebook and T-Hub’s India Innovation Accelerator program",
          visit_url:
            "https://www.thenewsminute.com/article/ten-startups-graduate-facebook-and-t-hub-s-india-innovation-accelerator-program-112978",
        },
        {
          logo: "financial_express.png",
          description:
            "Facebook, T-Hub pick these 10 AI startups for accelerator programme",
          visit_url:
            "https://www.financialexpress.com/industry/sme/facebook-t-hub-picks-these-10-ai-startups-for-accelerator-programme-offers-technology-mentoring-other-support/1647387/",
        },
      ],
      awardLogos: [
         {
          logo: "uk_trade.png",
          description: "UK Trade and Investment- Great Tech Rocketships",
          visit_url:
            "https://www.gov.uk/government/world-location-news/six-indian-companies-emerge-as-winners-of-great-tech-rocketships-2016",
        },
        {
          logo: "mit.png",
          description:
            "MIT awards $250,000 for “Most Innovative Future of Work in the World”",
          visit_url:
            "https://www.forbes.com/sites/gradsoflife/2018/11/15/mit-awards-1-million-to-most-innovative-future-of-work-organizations-in-the-world/#3ba7c1e7668a",
        },
        {
          logo: "uniliver.png",
          description: "Unilever Young Entrepreneur Awards Recognition",
          visit_url:
            "https://www.unilever.com/about/inspiringaction/unilever-young-entrepreneurs-awards/awards-2018/meet-our-2018-young-entrepreneurs-awards-highly-commended-semi-finalists/?fbclid=IwAR2pSpkZoyQfrc2Ma-rziZM71Z2t6pSJ16mNPeP3rQGkapaJwVv8CZ87-lU",
        },
        {
          logo: "ntt_data_innovation.png",
          description: "NTT Data Open Innovation 7.0 – Global Winner",
          visit_url: "https://oi.nttdata.com/en/contest/7th/about/",
        },
        {
          logo: "nasscom_emerge.png",
          description: "NASSCOM Emerge 50",
          visit_url: "https://www.nasscom.in/emerge50/Emerge-50-2016.Pdf",
        },
        {
          logo: "nasscom_awards_2019.png",
          description: "NASSCOM India Fintech Awards",
          visit_url: "http://10000startups.com/IndiaFintechDay2019/",
        },
        {
          logo: "ibm_smart_camp.png",
          description: "IBM Fintech Smart Camp",
          visit_url: "https://inc42.com/buzz/winners-ibm-smartcamp/",
        },
        {
          logo: "red_herring_asia.png",
          description: "Red Herring Asia 50",
          visit_url:
            "http://www.redherring.com/events/red-herring-asia/2016-finalists/",
        },
        {
          logo: "kpmg_100.png",
          description: "KPMG Hot 100 Startups",
          visit_url:
            "https://www.industrialautomationindia.in/newsitm/5950/MIT-Awards-$250,000-to-ftcash-for-Most-Innovative-Future-of-Work-in-the-World/news",
        },
        {
          logo: "singapore.png",
          description: "Awarded by Singapore Fintech Festival",
          visit_url: "https://fintechnews.sg/tag/ftcash/",
        },
        {
          logo: "sankalp_global_summit.png",
          description: "Winner at 10th Global Summit",
          visit_url:
            "https://www.intellecap.com/announcements/10th-sankalp-global-summit-2018-concludes-successfully-with-debate-and-discussions-on-serving-the-underserved-3-billion-people/",
        },
        {
          logo: "pitch_rb.png",
          description: "ftcash participates in the 3rd ‘Festival of Innovation’ with a Pitch@RB at Rashtrapati Bhavan",
          visit_url: "https://www.channelinfoline.com/article/ftcash-participates-in-the-3rd-festival-of-innovation-with-a-pitchrb-at-rashtrapati-bhavan/",
        },
        {
          logo: "iim_ahmedabad.png",
          description: "IIM Ahmedabad CIIE Fellowship",
          visit_url: "https://ciie.co/",
        },
        {
          logo: "mBillionth.png",
          description: "mBillionth Awards",
          visit_url: "http://mbillionth.in/business-commerce-winners-2016/",
        },
        {
          logo: "the_fintech_20.png",
          description: "The Fintech20: India",
          visit_url: "https://issuu.com/fintechcity/docs/ft50_16_spreads_lo/20",
        },
        {
          logo: "nasscom_retech.png",
          description: "NASSCOM & Retailers Association of India",
          visit_url: "https://retechcon.com/retechstartupawards2016/",
        },
        {
          logo: "village_capital.png",
          description: "FinTech India",
          visit_url: "https://www.profitbooks.net/profitbooks-named-in-top-3-fintech-companies-in-india/",
        }
      ],
      paragraph: {
        first:
          "Started in 2015 with an aim to empower small business merchants, we have managed to bridge the lending gap for many of our customers. Armed with frenetic energy and innovative ideas, we come to work every day with a passion to make a difference with fintech.  ",
        second:
          "Our achievements were applauded with many accolades such as Great Tech Rocketships Initiative Award, NASSCOM Emerge Award, Audience Award at NTT Data Open Innovation Award and Young Entrepreneur’s Award from Unilever",
        third:
          "As the world notices are efforts to empower small businesses and merchants, here’s who said what about us",
      },
      videos: [
        {
          video_thumbnail: "vaibhav_sir_thumbnail1.jpg",
          video_url: "https://www.youtube.com/embed/exhUIN7Hofs",
          video_description:{
            line1:'NDTV The Real Deal - Vaibhav Lodha, Co founder, ftcash. ',
            line2:'Vaibhav is the Co founder of fTCash, a PayPal backed startup in the financial technology space serving the underserved micro-merchants in India'

          } 
        },
        {
          video_thumbnail: "sanjeev_sir_thumbnail.jpg",
          video_url: "https://www.youtube.com/embed/nJEuoKCZLZY",
          video_description: {
            line1:'OCBCxSFF2017 Day 3: Hackcelerator Finalist – ',
            line2:'ftcash was the finalist on day three of the Singapore FinTech Festival 2017'
          }
        },
        {
          video_thumbnail: "deepak_sir_thumbnail.jpg",
          video_url: "https://www.youtube.com/embed/eIwfG_QKrz0",
          video_description:{
            line1:'Fintech AbuDhabi, Innovation Challenge - Part One (featuring ftcash)',
            line2:'ftcash providing a demo of solutions to FinTech Problem sets.'
          
          }
        },
        {
          video_thumbnail: "vaibhav_sir_thumbnail2.jpg",
          video_url: "https://www.youtube.com/embed/9qoCR4SUEvM",
          video_description: {
            line1:'ftcash - 2017 Global FinTech Hackcelerator Demo',
            line2:"ftcash's 5-minute pitch at Demo Day, held on 16 November 2017, Singapore FinTech Festival."
          }
        },
      ],
       partners: [
         {
          partner_name: "Stanford",
          partner_image: "stanford.png",
          partner_url: "https://www.stanford.edu/",
        },
        {
          partner_name: "Paypal",
          partner_image: "paypal_logo.png",
          partner_url: "https://www.paypal.com/",
        },
        {
          partner_name: "Mastercard",
          partner_image: "mastercard.png",
          partner_url: "https://www.mastercard.co.in/en-in.html",
        },
        {
          partner_name: "Facebook",
          partner_image: "facebook.png",
          partner_url: "https://www.facebook.com/",
        },
        {
          partner_name: "ISB",
          partner_image: "isb.png",
          partner_url: "https://www.isb.edu/en.html",
        },
        {
          partner_name: "Acumen",
          partner_image: "acumen.png",
          partner_url: "https://acumen.org/",
        },
        {
          partner_name: "Bain&Co",
          partner_image: "bain.png",
          partner_url: "https://www.bain.com/",
        },
        {
          partner_name: "MIT",
          partner_image: "massachusetts.png",
          partner_url: "https://www.mit.edu/",
        },
      ],
    };
  },
  mounted() {
   
     this.$refs.awardsstart.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
    // window.scrollTo(0, 0);
  },
  metaInfo() {
    return{
    
    link: [
      { rel: 'canonical', href: 'https://www.ftcash.com/awards' },
    ],
    }
  },
};
</script>

<style scoped>
section#media-intro {
  height: 100vh;
  background-image: url("../../assets/img/media_and_awards_bg.jpg");
  background-position: center 20%;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}
section#partners {
  display: flex;
}
/* Features */
.awards, .medias, .media-recognition, .partners {
  position: relative;
}
.features-image-bg {
 width: 92px;
  height: 114px;
  float: right;
}
.features-head {
   font-size: 3.3rem;
  position: absolute;
  right: 67px;
  float: right;
  z-index: 2;
  top: 49px;
}
/* Gallery */
.recog-head {
       font-size: 3.3rem;
    position: absolute;
    right: 60px;
    float: right;
    z-index: 2;
    top: 45px;
}
/*
.recognition {
  position: absolute;
  margin: auto;
  top: 35%;
  bottom: 100%;
  left: 0;
  right: 0;
}*/
/* Awards & Media */
/*
.awards-main-section {
  margin-top:7rem;
}*/
/* Mid Sections */
.recognition-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
 /* background-color: rgba(226, 243, 250, 0.5); */
}
.awards-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
.video-carousel-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
 /* background-image: url("../../assets/background/video_carousel_bg.jpg");*/
  background-color: #1f3d73;
  /* background-position: -47.5 center; */
  background-repeat: no-repeat;
  background-size: cover;
  /*background-position: 228px 1%; */
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  width: 100vw;
}
.media-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
 /*  background-image: url("../../assets/background/media_bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover; */
}
.partners-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}



.awards-title-section {
 width: 100vw;
  min-height: 114px;
  background-image: url("../../assets/background/awards_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  /*position: absolute;
  top: 0;*/
  z-index: -2;
}
.award-title {
  font-size: 3.5rem;
  padding-bottom: 0;
  margin-bottom: 0;
  line-height: 0.7;
  float: right;
}
.awards-image-bg {
  width: 160px;
  height: 130px;
  float: right;
}
.awards-head {
   font-size: 3.3rem;
    position: absolute;
    right: 64px;
    float: right;
    z-index: 2;
    top: 46px;
}
.awards-img {
   right: 0;
  z-index: -1;
}
.media-head {
    font-size: 3.3rem;
    position: absolute;
    right: 61px;
    float: right;
    z-index: 2;
    top: 47px;
}
/*
.media-body, .partners-body {
  position: absolute;
  margin: auto;
  top: 50%;
  bottom: 100%;
  left: 0;
  right: 0;
}*/
/* External Partners */
.partners-head {
      font-size: 3.3rem;
    position: absolute;
    right: 68px;
    float: right;
    z-index: 2;
    top: 46px;
}
.color_white {
  color: white;
}

/* Video Carousel*/
.video-carousel-head{
     font-size: 3.3rem;
    position: absolute;
    right: 75px;
    float: right;
    z-index: 2;
    top: 46px;
}
.video-carousel-image-bg{
      width: 100px;
    height: 114px;
    float: right;
}
#video-carousel {
 
  position:relative;
}
#media {
  
}
#testimonial-title > h1 {
  font-size: 3.5rem;
  padding-bottom: 0;
  margin-bottom: 0;
  line-height: 0.7;
}

/* Media Queries */
/* Tablet Screen */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  section#media-intro {
    height: 100vh;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    scroll-snap-align: center;
  }
  section#video-carousel {
    min-height: 100vh;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    scroll-snap-align: center;
  }
  

  /*.mid {
    margin-top: 4rem;
  } */
  .features-image-bg {
    width: 90px;
    height: 114px;
    float: right;
  }
  
  /* Heads */
  .video-carousel-head,.partners-head,.awards-head,.features-head,.recog-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 1.25rem 0rem;
    width: 100%;
    text-align: center;
    bottom: 0;
    right: 0;
    float: none;
  }
  /* Awards & Media */
 /* .awards-main-section {
    margin-top:7rem;
  } */
  .awards-title-section {
    width: 100vw;
    min-height: 114px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
   /* position: absolute;
    top: 0;*/
  }
  .award-title {
    font-size: 3.5rem;
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 0.7;
    float: right;
  }
  .awards-image-bg {
    width: 160px;
    height: 130px;
    float: right;
  }
  
  .awards-img {
    position: static;
    bottom: 0;
    right: 0;
  }
  .media-head {
   
    font-size: 1.75rem;
    position: absolute;
    padding: 1.25rem 0rem;
    width: 100%;
    text-align: center;
    bottom: 0;
    right: 0;
    float: none;
  }
 
}
/* Mobile Screen */
@media (min-width: 481px) and (max-width: 767px) {
  section#media-intro {
    height: 45vh;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    scroll-snap-align: center;
  }
   section#awards {
    min-height: auto;
    display: flex !important;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    scroll-snap-align: center;
  }

 section#media{
    min-height: auto;
    display: flex !important;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    scroll-snap-align: center;
   /*  background-image: url("../../assets/background/media_bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover; */
   z-index: 2;
 }
  section#video-carousel {
   min-height: 70vh;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    scroll-snap-align: center;
    /* background-position: 62.5% 100%; */
    background-color:var(--mainBlueColor);
    z-index:2;
  }
  section#media-recognition {
    min-height: auto;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    scroll-snap-align: center;
   /*  background-color: rgba(226, 243, 250, 0.5); */
    z-index: 2;
  }
 

 .mid {
    padding: 10% 0;
  }
  .features-image-bg {
    width: 36px;
    height: 60px;
  }
  .features-head {
        font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  /* Gallery */
  .recog-head {
        font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  .recognition, .media-body {
    position: static;
    margin: 67px 0 0 0;
  }
  .media-b{
    padding-top:45px;
  }
  .partners-body {
    position: static;
    padding-top: 19px;
  }
  /* Awards & Media */
  .awards-main-section {
    margin-top:45px;
  }
  .awards-title-section {
     width: 100vw;
    min-height: 60px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
  }
  .award-title {
    font-size: 3.5rem;
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 0.7;
    float: right;
  }
  .awards-image-bg {
    width: 160px;
    height: 130px;
    float: right;
  }
  .awards-head {
         font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  .awards-img {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .media-head {
        font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  /* External Partners */
  .partners-head {
         font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  .video-carousel-mid-section{
   background-color: transparent;
   background-image: none;
}
.video-carousel{
  margin-top: 70px;
}
.video-carousel-image-bg{
    width: 36px;
    height: 60px;
  }
.recognition-mid-section{
  background-color: transparent;
}
.video-carousel-head{
   font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
}
}
@media (max-width: 480px) {
  section#media-intro {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    scroll-snap-align: center;
  }
  section#media {
     min-height: 75vh;
    display: flex !important;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    scroll-snap-align: center;
   /*  background-image: url("../../assets/background/media_bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover; */
   z-index: 2;
  }
  section#awards {
    min-height: auto;
    display: flex !important;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    scroll-snap-align: center;
  }
  section#video-carousel {
   min-height: 70vh;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    scroll-snap-align: center;
    /* background-position: 62.5% 100%; */
    background-color:var(--mainBlueColor);
    z-index:2;
  }

  .mid {
    padding: 2rem 0;
  }
  .features-image-bg {
    width: 36px;
    height: 60px;
  }
  .features-head {
     font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  /* Gallery */
  .recog-head {
     font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  /*.recognition {
    position: static;
    margin: 45px 0 0 0;
  }*/
  .recognition {
    position: static;
    padding-top: 63px;
  }
  /* Awards & Media */
  .awards-main-section {
    margin-top:55px;
  }
  .awards-title-section {
    width: 100vw;
    min-height: 60px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
  }
  .award-title {
    font-size: 3.5rem;
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 0.7;
    float: right;
  }
  .awards-image-bg {
    width: 160px;
    height: 130px;
    float: right;
  }
  .awards-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  .awards-img {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .media-head {
     font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  /* External Partners */
  .partners-head {
     font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  /* Video Carousel*/
  .video-carousel-image-bg{
    width: 36px;
    height: 60px;
  }
  .video-carousel-head{
   font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
}
.recognition-mid-section{
  background-color: transparent;
}
.video-carousel-mid-section{
   background-color: transparent;
   background-image: none;
}

.video-carousel{
  margin-top: 70px;
}


.media-mid-section{
   background-image: none;
   margin-top:55px;
}

.partners{
  padding-top: 28px;
}
section#media-recognition{
   /*background-color: rgba(226, 243, 250, 0.5);*/
    z-index: 2;
}
}
</style>